<template>
  <div v-if="loading" class="comment-box">
    <div class="comment-area">
      <editor :placeholder="placeholder" :replyResult="replyResult"></editor>
    </div>
    <div @click="saveData" class="comment-foot">
      <div>{{bnt_text}}</div>
    </div>
  </div>
</template>

<script>
import * as dd from "dingtalk-jsapi";
import editor from "@/components/Share/index";
//import editor from "../../Share/Editor-at";
//import editor from "@/components/Share/Editor/index";
import http from "@/utils/http";
import { mapState, mapMutations } from "vuex";
const { menuItem } = require(`@/config/develop.json`);
export default {
  data() {
    return {
      bnt_text: "",
      loading: false,
      replyResult: {},
      placeholder:'请输入审批意见'
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      dingdingconfig: state => state.dingdingconfig,
      browser:state=>state.browser
    })
  },
  components: {
    editor,
    scroll
  },
  methods: {
    ...mapMutations(["setTitleInfo"]),
    complexChoose() {
      let _this = this;
      return new Promise(function(resolve, reject) {
        dd.biz.contact.complexPicker({
          title: "选择转交人", //标题
          corpId: _this.dingdingconfig.corpId, //企业的corpId
          multiple: false, //是否多选
          limitTips: "超出了", //超过限定人数返回提示
          maxUsers: 1, //最大可选人数
          pickedUsers: [], //已选用户
          pickedDepartments: [], //已选部门
          disabledUsers: [], //不可选用户
          disabledDepartments: [], //不可选部门
          requiredUsers: [], //必选用户（不可取消选中状态）
          requiredDepartments: [], //必选部门（不可取消选中状态）
          appId: _this.dingdingconfig.agentId, //微应用的Id
          permissionType: "GLOBAL", //可添加权限校验，选人权限，目前只有GLOBAL这个参数
          responseUserOnly: true, //返回人，或者返回人和部门
          startWithDepartmentId: -1, //仅支持0和-1
          onSuccess: function(result) {
            resolve(result);
          },
          onFail: function(err) {
            resolve({ code: -1 });
          }
        });
      });
    },
    saveData() {
      let _this = this;
      this.replyResult.replyText = this.replyResult.replyText.replace(
        /&nbsp;/gi,
        ""
      );
      if (this.replyResult.replyText.length > 0 && this.url) {
        if (
          this.replyResult.needSignatureFlag == "" &&
          this.$route.query.isEnd &&
          1 == 2
        ) {
          this.$Message["error"]({
            background: true,
            content: "请选择是否要签名？"
          });
        } else {
          this.$Spin.show();
          this.replyResult.fileList = [];
          if (this.replyResult.fileInfo.filesrcs.length > 0) {
            var fileSrcArr = this.replyResult.fileInfo.filesrcs.split("|");
            var fileNameArr = this.replyResult.fileInfo.filenames.split("|");
            fileSrcArr.forEach((item, index, arr) => {
              if (item.length > 0)
                this.replyResult.fileList.push({
                  filePath: item,
                  name: fileNameArr[index]
                });
            });
          }
          _this.requestData(_this.url, _this.replyResult).then(res => {
            _this.$Spin.hide();
            _this.$router.go(-1);
          });
        }
      } else {
        this.$Message["error"]({
          background: true,
          content: _this.placeholder
        });
      }
    },
    requestData(url, saveDatainfo) {
      return new Promise(function(resolve, reject) {
        http({
          method: "post",
          url: url,
          data: saveDatainfo
        }).then(res => {
          resolve(res);
        });
      });
    },
    confirmOperate(operate, applyTypeId) {
      var item = menuItem[applyTypeId];
      switch (operate) {
        case 0:
          this.setTitleInfo({ title: "确认拒绝", bg: "default" });
          this.url = `/api${item}/Apply_Denied`;
          this.loading = true;
          this.bnt_text = "确认拒绝";
          break;
        case 1:
          this.setTitleInfo({ title: "确认同意", bg: "default" });
          this.url = `/api${item}/Apply_Pass`;
          this.loading = true;
          this.bnt_text = "确认同意";
          break;
        case 2:
          this.complexChoose().then(res => {
            console.log(res);
            if (res.code && res.code == -1) {
              this.$router.go(-1); //返回上一层
            } else {
              this.setTitleInfo({
                title: "转交给" + res.users[0].name,
                bg: "default"
              });
              this.replyResult.receiveDingDingId = res.users[0].emplId;
              this.loading = true;
              this.bnt_text = "转交";
              this.placeholder="请输入转交意见";
            }
          });
          this.url = `/api${item}/Apply_Forwarded`;
          break;
        default:
          this.setTitleInfo({ title: "评论", bg: "default" });
          this.replyResult.approvePostID = this.userInfo.postID;
          this.url = `api${item}/Apply_Comment`;
          this.loading = true;
          this.bnt_text = "提交评论";
           this.placeholder="请输入评论内容";
      }
    }
  },
  mounted() {
    this.replyResult = {
      ...this.$route.query,
      employeeId: this.userInfo.employeeID,
      replyText: "",
      atPeople: [],
      fileInfo: { filesrcs: "", filenames: "" },
      isChatNotice: true, //是否会话通知(暂时不用)
      signaturePath: "",
      currentApplyEmployeeName: this.userInfo.employeeName,
      needSignatureFlag: "" //采购终审的时候需要
    };
    this.confirmOperate(
      this.$route.query.operate,
      this.$route.query.applyTypeId
    );
  }
};
</script>

<style scoped="scoped" lang="less">
.comment-box {
  width: 100%;
  height: 100%;  
  display: flex;
  flex-direction: column;
  .comment-area {
    flex: 1;
    padding: 0 0.4rem;
    overflow-y: auto;
  }
  .comment-checkbox {
    width: 100%;
    height: 0.666667rem;
    padding: 0 0.4rem;
  }
  .comment-foot {
    height: 1.6rem;
    display: flex;
    padding: 0 0.4rem;
    align-items: center;
    justify-content: center;
    box-shadow: 0 -0.026667rem 0.133333rem 0;
    div {
      width: 100%;
      height: 0.96rem;
      line-height: 0.96rem;
      font-size: 0.426667rem;
      color: #fff;
      letter-spacing: 2px;
      text-align: center;
      background-image: linear-gradient(121deg, #ffd10a 0%, #ff9e07 100%);
      box-shadow: 0 2px 8px 0 rgba(255, 207, 104, 0.7);
      border-radius: 0.533333rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Approval/comment/index.vue